module.exports = __webpack_public_path__ + "img/uva.c052481c.png";